import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { useState } from 'react';
import { Modal } from '@fasstech/middle-design-system';
import FooterExtraForm from '@@app/extra/FooterExtraForm';
import classNames from 'classnames';

const Footer = ({
  getMiddleBoolean,
  getMiddleText
}) => {
  const [displayPersonalDataModal, setDisplayPersonalDataModal] = useState(false);
  const [displayAccessibilityModal, setDisplayAccessibilityModal] = useState(false);

  const cookiesAccess = getMiddleText('PROCESSDEVENTE_LIEN_COOKIES_ACCES');
  // A URL starts with a scheme (http:, mailto:, ...) or a leading slash; anything else
  // is treated as an analytics/CMP script snippet (e.g. `tC.event.privacy_center()`) to run on click.
  const isCookiesAccessUrl = /^([a-z][a-z0-9+.-]*:|\/)/i.test(cookiesAccess);
  return (
    <>
      <div className="flex gap-2 w-full bg-white justify-between items-center p-4">
        <div className="flex-1"></div>
        <div className="flex gap-2 justify-center flex-1 md:whitespace-nowrap">
          {getMiddleBoolean('PROCESSDEVENTE_DONNEES_PERSONNELLES_EST_NECESSAIRE') && (<>
            <button
              className="underline cursor-pointer"
              onClick={() => setDisplayPersonalDataModal(true)}>
              {getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_LIEN_LABEL')}
            </button>
            <span>|</span>
          </>)}
          <button
            className="underline cursor-pointer"
            onClick={() => setDisplayAccessibilityModal(true)}>
            {getMiddleText('PROCESSDEVENTE_ACCESSIBILITE_CGV_LIEN_LABEL')}
          </button>
          {getMiddleBoolean('PROCESSDEVENTE_LIEN_COOKIES_EST_NECESSAIRE') && (<>
            <span>|</span>
            <a
              href={isCookiesAccessUrl ? cookiesAccess : '#'}
              target={isCookiesAccessUrl ? '_blank' : undefined}
              rel={isCookiesAccessUrl ? 'noopener noreferrer' : undefined}
              onClick={isCookiesAccessUrl ? undefined : (event) => {
                event.preventDefault();
                new Function(cookiesAccess)();
              }}
              className="underline cursor-pointer">
              {getMiddleText('PROCESSDEVENTE_LIEN_COOKIES_LABEL')}
            </a>
          </>)}
        </div>
        <div className="flex-1 flex justify-end">
          <span
            className="text-xs text-gray-500 whitespace-nowrap">v{__TAG_VERSION__}</span> {/* eslint-disable-line no-undef */}
        </div>
      </div>
      <Modal
        isDisplayed={displayPersonalDataModal}
        onClose={() => setDisplayPersonalDataModal(false)}
        icon="circleLegal"
        iconSize={60}
        className="max-w-2xl max-h-[95vh]"
        containerClassName="px-3">
        <>
          <div className="text-lg sm:text-xl md:text-2xl! font-semibold mb-4">
            {getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_LIEN_LABEL')}
          </div>

          <div
            className="overflow-y-auto text-[10px] sm:text-xs md:text-sm text-left"
            dangerouslySetInnerHTML={{ // dangerouslySetInnerHTML is OK as long as the text comes from a Fasst-controlled CMS field
              __html: getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_TEXT')
            }}></div>
          <FooterExtraForm/>
        </>
      </Modal>
      <Modal
        isDisplayed={displayAccessibilityModal}
        onClose={() => setDisplayAccessibilityModal(false)}
        icon="circleLegal"
        iconSize={60}
        className="max-w-2xl max-h-[95vh]"
        containerClassName="px-3">
        <>
          <div
            className={classNames(
              'overflow-y-auto text-[10px] sm:text-xs md:text-sm text-left',
              '[&_p]:my-2 [&_ul_p]:my-0.5 [&_ul]:list-disc [&_ul]:pl-6 [&_ul_ul]:[list-style-type:circle]'
            )}
            dangerouslySetInnerHTML={{ // dangerouslySetInnerHTML is OK as long as the text comes from a Fasst-controlled CMS field
              __html: getMiddleText('PROCESSDEVENTE_ACCESSIBILITE_TEXT')
            }}></div>
          <FooterExtraForm/>
        </>
      </Modal>
    </>
  );
};

export default withMiddleFeatures(Footer);
